module.exports = __webpack_public_path__ + "img/logo-shop.b244bfb3.png";